export default "__VITE_ASSET__CTf0x73c__"